import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  message,
  Tooltip,
  Checkbox,
  Select,
  Form,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import ModalWrapper from './ModalWrapper';
import LabelPickerTray from './LabelPickerTray';
import './addLabelModal.scss';

const { Option } = Select;

class AddLabelToRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendTokens: props.modalType.data.record,
      receiverType: props.modalType.data.receiverType,
      labels: [],
      selectedLabels: [],
      searchValue: '',
      isDocumentWronglyLabeled: false,
      correctLabel: null,
      correctLabelValidateStatus: '',
      help: '',
    };
  }

  componentDidMount = async () => {
    // eslint-disable-next-line react/destructuring-assignment
    const page = 1;
    const pageSize = 'max';
    // Surface the labels this user applies most (last 30 days) at the top.
    const sort = 'user_label_usage';
    const { getLabelsByPage } = this.props;
    await getLabelsByPage(page, pageSize, sort);
    const { data, selectedRecord, modalType } = this.props;
    const initialSelectedLabels = modalType.data.selectedLabelsRecordViewer
      ? modalType.data.selectedLabelsRecordViewer
      : selectedRecord[0].labels;
    this.setState({
      labels: data,
      selectedLabels: [...initialSelectedLabels],
    });
  }

  selectLabel = (label) => {
    const { selectedLabels } = this.state;
    const currentlySelected = [...selectedLabels];
    const indexOfSelectedLabel = currentlySelected.findIndex(selectedLabel => selectedLabel.name === label.name);
    const labelAlreadySelected = currentlySelected.find(selectedLabel => selectedLabel.name === label.name);
    if (!labelAlreadySelected) {
      this.setState({
        selectedLabels: [...currentlySelected, label],
      });
    } else {
      currentlySelected.splice(indexOfSelectedLabel, 1);
      this.setState({
        selectedLabels: currentlySelected,
      });
    }
  }

  deselectLabel = (label, index) => {
    const { selectedLabels } = this.state;
    const currentlySelected = [...selectedLabels];
    currentlySelected.splice(index, 1);
    this.setState({
      selectedLabels: currentlySelected,
    });
  }

  update = async (event) => {
    event.preventDefault();
    const {
      sendTokens,
      selectedLabels,
      receiverType,
      isDocumentWronglyLabeled,
      correctLabel,
    } = this.state;
    if (isDocumentWronglyLabeled && !correctLabel) {
      this.setState({
        correctLabelValidateStatus: 'error',
        help: 'Please select a label',
      });
      return;
    }
    const { editReceivedRecordLabels } = this.props;
    const selectedLabelIds = [];
    selectedLabels.map(label => selectedLabelIds.push(label.id));
    await editReceivedRecordLabels(sendTokens, selectedLabelIds, selectedLabels, receiverType, isDocumentWronglyLabeled, correctLabel);

    const { updatedLabel, hideModal } = this.props;
    if (updatedLabel) {
      hideModal();
      message.success({
        content: 'Labels changed',
      });
      this.updateRowSelected();
    }
  }

  updateRowSelected() {
    const { selectedLabels, fileToken } = this.state;
    const { modalType, rowSelected } = this.props;
    const selectedRow = {
      labels: selectedLabels,
      file_token: fileToken,
      index: modalType.data.record.index,
    };
    rowSelected([selectedRow]);
  }

  renderLabelIncorrectCheckBox = () => {
    const { isDocumentWronglyLabeled } = this.state;
    return (
      <div className="add-label-modal__report">
        <Checkbox
          checked={isDocumentWronglyLabeled}
          onChange={() => this.setState(prevState => ({
            isDocumentWronglyLabeled: !prevState.isDocumentWronglyLabeled,
          }))}
          disabled={false}
        >
          Has document been wrongly labeled?
        </Checkbox>
        <Tooltip
          title="Reporting errors with our AI Labeling will help us train our model and become more accurate in the future"
        >
          <QuestionCircleOutlined className="add-label-modal__report-help" />
        </Tooltip>
      </div>
    );
  }

  renderModal = () => {
    const { isLoading, hideModal: handleHideModal } = this.props;
    const {
      labels, selectedLabels, searchValue, isDocumentWronglyLabeled,
    } = this.state;
    const { modalType: { data: { reportAiDetails } } } = this.props;
    const { isLabelEdited, hasWrongLabelingBeenReported, aiStatus } = reportAiDetails;
    const hasDocumentBeenClassified = !!aiStatus;
    if (isLoading) {
      return (<span> Updating labels, Please wait... </span>);
    }
    const maxAdditionalLabels = 5 - selectedLabels.length;
    return (
      <div className="add-label-modal">
        <LabelPickerTray
          labels={labels}
          maxAdditionalLabels={maxAdditionalLabels}
          selectedLabels={selectedLabels}
          selectedTitle="Current labels"
          emptySelectedText="No labels selected yet"
          searchValue={searchValue}
          onSearchChange={(value) => this.setState({ searchValue: value })}
          onSelectLabel={this.selectLabel}
          onDeselectLabel={this.deselectLabel}
          onClearLabels={() => this.setState({ selectedLabels: [] })}
          onManageLabelsClick={handleHideModal}
          showClear={true}
        />

        {hasDocumentBeenClassified && !isLabelEdited && !hasWrongLabelingBeenReported && this.renderLabelIncorrectCheckBox()}
        {isDocumentWronglyLabeled && this.renderCorrectLabelInput()}
      </div>
    );
  }

  handleChangeSelect = (value) => {
    return this.setState({
      correctLabel: value,
      correctLabelValidateStatus: '',
      help: '',
    });
  }

  renderCorrectLabelInput = () => {
    const { labels, correctLabelValidateStatus, help } = this.state;
    return (
      <Form.Item
        name="label"
        label="Correct Label"
        rules={[{ required: true }]}
        validateStatus={correctLabelValidateStatus}
        help={help}
      >
        <Select
          showSearch
          placeholder="Select a label"
          optionFilterProp="children"
          onChange={value => this.handleChangeSelect(value)}
          style={{ width: 200 }}
          filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {labels.map(label => <Option value={label.name}>{label.name}</Option>)}
        </Select>
      </Form.Item>
    );
  }

  render() {
    const { isLoading, hideModal } = this.props;
    const customContentStyle = {
      width: '460px',
    };

    return (
      <ModalWrapper
        hideModal={hideModal}
        customContentStyle={customContentStyle}
        width="460px"
        wrapClassName="add-label-modal-wrap"
        action={this.update}
        actionName="Submit"
        dismiss={isLoading ? '' : 'Cancel'}
        disabled={isLoading}
        modalTitle="Add or edit labels"
        form="addLabelToRecord"
      >
        <Form
          layout="vertical"
          onFinish={this.update}
          id="addLabelToRecord"
        >
          {this.renderModal()}
        </Form>
      </ModalWrapper>
    );
  }
}

AddLabelToRecord.propTypes = {
  hideModal: PropTypes.func.isRequired,
  modalType: PropTypes.object.isRequired,
  rowSelected: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  updatedLabel: PropTypes.bool.isRequired,
  editReceivedRecordLabels: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  selectedRecord: PropTypes.array.isRequired,
  getLabelsByPage: PropTypes.func.isRequired,
};

export default connect(state => ({
  isLoading: state.records.isLoading,
  emailValidMessage: state.records.emailValidMessage,
  updatedLabel: state.records.updatedLabel,
  data: state.labels.data,
  selectedRecord: state.inboxTable.recordData,
}))(AddLabelToRecord);
